import $ from 'jquery';

const radioDeselectListener = (formWrapperID) => {
	const $radioGroup =
		formWrapperID !== '' ? $(`div[id*="${formWrapperID}"] .form-field :input[type=radio]`) : $('.form-field :input[type=radio]');
	$radioGroup.on('change', function () {
		$radioGroup.each(function () {
			$(this).attr('dl-value', '');
		});
	});
};

const fillFormFields = (formWrapperID = '') => {
	let $inputs;
	if (formWrapperID !== '') {
		$inputs = $(`div[id*="${formWrapperID}"] .form-field :input:not([name^='SpamShield'])`);
	} else {
		$inputs = $('.form-field :input');
	}
	let fields = fillInputs($inputs);
	return fields;
};

const fillFormFieldsByWrapperClass = (wrapperClass = '') => {
	const $inputs = $(`.${wrapperClass} :input:not([name^='SpamShield'])`);
	const fields = fillInputs($inputs);
	return fields;
};

const getUpdatedFormField = (id, name = '') => {
	const checkboxRegex = /_CheckList_\d+__IsSelected$/;
	const radioCheck = ['elektrina', 'plyn'];
	// Is radio button for production type.
	if (name.includes('ProductionType')) {
		return ['ProductionType'];
	}
	// Is Multiple checkboxes
	if (checkboxRegex.test(id)) {
		return [id.replace(checkboxRegex, '')];
	}
	const radioItem = radioCheck.find((item) => id.startsWith(item));
	if (radioItem) {
		return radioItem;
	}
	const suffixRegex = /_(Value|File)$/;
	if (suffixRegex.test(id)) {
		return [id.replace(suffixRegex, '')];
	}
	return [id];
};

// Get leadProductType for Kentico form or form submit redirect page.
const getLeadProductType = (formWrapperID) => {
	const regexMacro = /^{%.*%}$/;
	const $form = $(`div[id*="${formWrapperID}"]`).first();
	const formLeadProductType = $form.attr('lead-product-type');
	let result;

	// LeadProductType in db contains macro.
	if (regexMacro.test(formLeadProductType)) {
		const inputName = formLeadProductType.slice(2, -2);
		const $inputs = $(`[id*="${formWrapperID}"] .form-field :input[name*="${inputName}"]:checked`);
		let attrVal = [];
		$inputs.each(function () {
			switch ($(this).attr('type')) {
				case 'radio':
					attrVal.push($(this).attr('id'));
					break;
				case 'checkbox':
					attrVal.push($.trim($(this).parent().text()));
					break;
			}
		});
		attrVal = attrVal.filter((n) => n);
		if (attrVal.length > 0) {
			result = attrVal.join(', ');
		}
		// Input from macro doesn't exist or is not selected yet.
		else {
			const commodityType = $form.attr('commodity-type');
			// Try to get leadProductType from previously selected commodity-type.
			if (commodityType) {
				result = $form.attr('commodity-type');
				// Input is in form, but leadProductType is not selected yet.
			} else {
				result = '';
			}
		}

		// LeadProductType in db is constant.
	} else {
		result = formLeadProductType;
	}
	return result;
};

// Get leadProductType on retence form.
const getLeadProductTypeByWrapperClass = (formWrapperClass, defaultLeadProductType) => {
	const attrVal = $(`.${formWrapperClass} :input[name="EnergySource"]:checked`).attr('id');
	return attrVal ? attrVal : defaultLeadProductType;
};

// Get leadProductType on Thank you partial page.
const getLeadProductTypeThankYouPage = (defaultLeadProductType) => {
	const commodityType = $('.formwidget-submit-text').first().attr('commodity-type');
	return commodityType ? commodityType : defaultLeadProductType;
};

const getSource = (source) => {
	switch (source) {
		case 'source-any':
			return 'elektrina-libovolna';
		case 'source-sun':
			return 'elektrina-slunce';
		case 'source-water':
			return 'elektrina-voda';
		case 'source-wind':
			return 'elektrina-vitr';
		case 'source-gas':
			return 'elektrina-bioplyn';
		default:
			return 'zadny';
	}
};

const getErrors = () => {
	let errors = [];
	$('.field-validation-error').each(function () {
		let dict = {};
		dict[$(this).attr('data-valmsg-for')] = $(this).text();
		errors.push(dict);
	});
	return errors;
};

const getRadioKey = (name, key) => {
	if (name.includes('ProductionType')) {
		return 'ProductionType';
	} else {
		return key.startsWith('elektrina') ? 'elektrina' : key.startsWith('plyn') ? 'plyn' : undefined;
	}
};

const fillInputs = ($inputs) => {
	let fields = {};
	const suffixRegex = /(.|_)(Value|File|CheckList_\d+__IsSelected)$/;
	$inputs.each(function () {
		const key = $(this).attr('id');
		if (key && $(this).attr('type') !== 'hidden') {
			let val = false;
			if ($(this).is('input')) {
				switch ($(this).attr('type')) {
					case 'radio':
						const $name = $(this).attr('name');
						val = $(this).is(':checked');
						const radioKey = getRadioKey($name, key);
						if (radioKey && (!(radioKey in fields) || !fields[radioKey])) {
							fields[radioKey] = val;
						}
						break;
					case 'checkbox':
						val = $(this).is(':checked');
						const checkboxKey = suffixRegex.test(key) ? key.replace(suffixRegex, '') : undefined;
						if (checkboxKey && (!(checkboxKey in fields) || !fields[checkboxKey])) {
							fields[checkboxKey] = val;
						}
						break;
					case 'file':
						val = $(this).get(0).files.length;
						if (suffixRegex.test(key)) {
							fields[key.replace(suffixRegex, '')] = !!val;
						} else {
							fields[key] = val > 0;
						}
						break;
					default:
						val = $(this).val();
						if (suffixRegex.test(key)) {
							fields[key.replace(suffixRegex, '')] = !!val;
						} else {
							fields[key] = !!val;
						}
				}
			} else if ($(this).is('select')) {
				val = $(this).find(':selected').text();
				fields[key.replace(suffixRegex, '')] = !!val;
			}
		}
	});
	return fields;
};

const addFunnelIDs = (data) => {
	const $innerBody = $('.form__body-inner');
	const funnelID = $innerBody.attr('funnel-id');
	const cmsID = $innerBody.attr('cms-id');
	if (funnelID) {
		data['funnelId'] = funnelID;
	}
	if (cmsID) {
		data['cmsId'] = cmsID;
	}
	return data;
};

const addQueryParam = (url, params, paramName) => {
	if (paramName in params) {
		url += `${paramName}=${params[paramName]}&`;
	}
	return url;
};

export default {
	radioDeselectListener,
	fillFormFields,
	getUpdatedFormField,
	fillFormFieldsByWrapperClass,
	getLeadProductType,
	getLeadProductTypeByWrapperClass,
	getSource,
	getLeadProductTypeThankYouPage,
	getErrors,
	getRadioKey,
	fillInputs,
	addFunnelIDs,
	addQueryParam,
};
